module.exports = __webpack_public_path__ + "img/icon-restaurant-mini-order.46d993c2.png";